import { ComputeVisibleCountParams } from './useHorizontalOverflow.types';

export function computeVisibleCount({
  widths,
  gap,
  availableWidth,
  reserve,
  minVisible,
}: ComputeVisibleCountParams): number {
  const totalWidth =
    widths.reduce((sum, width) => sum + width, 0) + gap * Math.max(0, widths.length - 1);

  if (totalWidth <= availableWidth) {
    return widths.length;
  }

  let used = 0;
  let count = 0;

  for (let index = 0; index < widths.length; index += 1) {
    const next = used + (index > 0 ? gap : 0) + widths[index];
    if (next + reserve > availableWidth) {
      break;
    }
    used = next;
    count += 1;
  }

  return Math.max(minVisible, count);
}
